export const environment = {
  production: true,
  apiUrl: 'http://rafaelm-002-site2.gtempurl.com',
  apiAddr: 'rafaelm-002-site2.gtempurl.com',
  ver: '1.119.5.PROD'
};
